<template>
    <div>
        <ProfileEdit v-dr-permission="'drg.app.profile.edit'" class="mb-6" />
        <EmailsEdit
            v-dr-permission="'drg.app.profile.emails.edit'"
            class="mb-6"
        />
        <PhonesEdit
            v-dr-permission="'drg.app.profile.phones.edit'"
            class="mb-6"
        />
    </div>
</template>

<script>
import EmailsEdit from "@/components/profile/manage/EmailsEdit";
import PhonesEdit from "@/components/profile/manage/PhonesEdit";
import ProfileEdit from "@/components/profile/manage/ProfileEdit";

export default {
    name: "ManageProfile",
    components: { ProfileEdit, EmailsEdit, PhonesEdit }
};
</script>

<style>
[data-view-type="profile"] .bb-view-background {
    background: var(--profile-background);
}
</style>
